import React from 'react'

/** 每个单元一层不同轮廓的山脉，只换山形，不画与课程无关的小图。 */
function ridge(stage, index) {
  const top = stage.rangeTop || 0
  const bottom = Math.max(top + 140, stage.rangeBottom || top + 200)
  const span = bottom - top
  const base = top + span * 0.42
  const peak = span * 0.22
  const kind = index % 4
  const fills = [
    'rgba(111, 159, 255, 0.34)',
    'rgba(125, 176, 230, 0.38)',
    'rgba(96, 148, 214, 0.34)',
    'rgba(138, 166, 224, 0.36)',
  ]
  const shapes = [
    `M0 ${base + peak * 0.4}
      C 80 ${base - peak * 0.2}, 160 ${base + peak * 0.7}, 250 ${base}
      S 400 ${base - peak * 0.5}, 500 ${base + peak * 0.2}
      S 580 ${base + peak * 0.6}, 640 ${base}
      V ${bottom} H 0 Z`,
    `M0 ${base + peak * 0.5}
      L 90 ${base + peak * 0.2}
      L 150 ${base - peak}
      L 210 ${base + peak * 0.35}
      L 300 ${base + peak * 0.1}
      L 390 ${base - peak * 0.85}
      L 470 ${base + peak * 0.4}
      L 560 ${base + peak * 0.15}
      L 640 ${base + peak * 0.45}
      V ${bottom} H 0 Z`,
    `M0 ${base - peak * 0.3}
      C 70 ${base - peak * 1.1}, 140 ${base - peak * 0.2}, 210 ${base + peak * 0.2}
      C 300 ${base + peak * 0.7}, 380 ${base + peak * 0.15}, 470 ${base + peak * 0.55}
      C 540 ${base + peak * 0.85}, 590 ${base + peak * 0.4}, 640 ${base + peak * 0.6}
      V ${bottom} H 0 Z`,
    `M0 ${base + peak * 0.55}
      L 70 ${base + peak * 0.55}
      L 110 ${base - peak * 0.7}
      L 250 ${base - peak * 0.7}
      L 290 ${base + peak * 0.2}
      L 360 ${base - peak * 0.15}
      L 430 ${base + peak * 0.45}
      L 520 ${base - peak * 0.9}
      L 590 ${base - peak * 0.2}
      L 640 ${base + peak * 0.3}
      V ${bottom} H 0 Z`,
  ]
  return (
    <path key={stage.stageKey} d={shapes[kind]} fill={fills[kind]} />
  )
}

export default function QuestParallax({ height, stages = [], farRef, midRef, nearRef }) {
  const h = Math.max(height || 0, 240)
  return (
    <div className="quest-parallax" aria-hidden="true">
      <svg ref={farRef} className="quest-parallax-layer is-far" viewBox={`0 0 640 ${h}`} preserveAspectRatio="none">
        {stages.map((stage, index) => ridge(stage, index))}
      </svg>
      <svg ref={midRef} className="quest-parallax-layer is-mid" viewBox={`0 0 640 ${h}`} preserveAspectRatio="none">
        {stages.map((stage, index) => {
          const y = (stage.rangeTop || 0) + 28
          return (
            <ellipse
              key={stage.stageKey}
              cx={index % 2 === 0 ? 120 : 500}
              cy={y}
              rx="46"
              ry="14"
              fill="rgba(232, 238, 247, 0.12)"
            />
          )
        })}
      </svg>
      <div ref={nearRef} className="quest-parallax-layer is-near" />
    </div>
  )
}
